import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import SplitPane from "react-split-pane";
import { FaDownload, FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { useParams } from "react-router";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { CiSearch } from "react-icons/ci";
import { studyEDCLupReportingServices } from "../../../APIServices/studyEDCLupReportingServices";
import DeletedReportList from "./DeletedReportList";
import UpdateReportData from "./UpdateReportData";
import Pagination from "../../Pagination";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import UseToggle from "../../../Hooks/UseToggle";
import FilePreview from "../../LUPManagement/FileManagement/FilePreview";

const ReportListing = ({ onMouseDown, tableRef, ids }) => {
  const { toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [reportId, setReportId] = useState("");
  const [reportData, setReportData] = useState("");
  const [reportURL, setReportURL] = useState("");
  const [reportList, setReportList] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [reportDeletedList, setReportDeletedList] = useState([]);
  const [reportDeletedListCount, setReportDeletedListCount] = useState(0);
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(reportCount / itemsPerPage);

  const getEDCLupReportList = async () => {
    setLoading(true)
    let data = await studyEDCLupReportingServices.getEDCLupReportList(
      "active",
      ids?.reportId,
      studyId,
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    )
    setReportList(data?.data || []);
    setReportCount(data?.count || 0);
    setLoading(false)
  }

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getEDCLupDeletedReportList = async (pageNumberDeleted, itemsPerPageDeleted) => {
    let data = await studyEDCLupReportingServices.getEDCLupReportList(
      "deleted",
      ids?.reportId,
      studyId,
      StudyMode,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setReportDeletedList(data?.data || []);
    setReportDeletedListCount(data?.count || 0);
  };

  useEffect(() => {
    if (ids?.reportId) {
      getEDCLupReportList();
    }
  }, [ids?.reportId, searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreEDCLupData = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} report!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.mode = StudyMode;
        userData.type = type;
        let data =
          await studyEDCLupReportingServices.softDeleteRestoreEDCLupData(
            userData
          );
        if (data?.statusCode === 200) {
          setReportId("")
          getEDCLupReportList();
          getEDCLupDeletedReportList();
          if (type === "restore") {
            getEDCLupDeletedReportList(
              pageNumberDeleted,
              itemsPerPageDeleted
            );
            setToggle1();
          }
        }
      }
    });
  };

  const downloadDocumentFile = async (reportURL) => {
    const anchor = document.createElement("a");
    anchor.href = reportURL;
    anchor.rel = "noopener noreferrer";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          {reportCount > 0 &&
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          }
        </div>
        {reportDeletedListCount > 0 &&
          <button
            onClick={() => {
              setToggle1();
              getEDCLupDeletedReportList(
                pageNumberDeleted,
                itemsPerPageDeleted
              );
            }}
            className={`updateProfile`}
          >
            Deleted History
          </button>
        }
      </div>
      <SplitPane
        split="vertical"
        minSize={100}
        style={{ height: "calc(100vh - 184px)" }}
        className="position-relative"
        defaultSize={reportURL ? "60%" : "100%"}
      >
        {loading ? (
          <PageLoader />
        ) : reportCount === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG="Report list not found" />
          </div>
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Name</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Type</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}
                    style={{ width: 120 }}>
                    GeneratedDt DT
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}
                    style={{ width: 120 }}>
                    Modified DT
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 5)}
                    style={{ width: 65 }}
                    className="text-center"
                  >
                    Download
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 6)}
                    style={{ width: 40 }}
                    className="text-center"
                  >
                    Edit
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 7)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {reportList?.map((item, index) => (
                  <tr
                    key={item?._id || index}
                    className={`CP ${reportId === item?.reportId ? "highlighted" : ""}`}
                    title="View Details"
                    onClick={() => {
                      setReportURL(item?.reportURL);
                      setReportId(item?.reportId);
                    }}
                  >
                    <td className="text-center">{index + 1 + startIndex}</td>
                    <td>{item?.name}</td>
                    <td className="text-uppercase">{item?.extension}</td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.createdAt}
                      </Moment>
                    </td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.updatedAt}
                      </Moment>
                    </td>
                    <td
                      className="text-center"
                      title={`Download ${item?.name}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadDocumentFile(item?.reportURL)
                      }}
                    >
                      <FaDownload />
                    </td>
                    <td
                      className="text-center"
                      title={`Update ${item?.name}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setReportData(item);
                        setToggle2();
                      }}
                    >
                      <FaEdit />
                    </td>
                    <td
                      className="text-center"
                      title={`Delete ${item?.name}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        softDeleteRestoreEDCLupData(item?._id, "delete");
                      }}
                    >
                      <FaTrash className="text-danger" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={reportCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
        {reportURL && (
          <FilePreview FileUrl={reportURL} ref={null} HeightData={"calc(100vh - 184px)"} />
        )}
      </SplitPane>

      <UpdateReportData
        Show={!toggle2}
        Hide={setToggle2}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        Title={"Update Report"}
        reportData={reportData}
        setReportData={setReportData}
        setReportId={setReportId}
        getEDCLupReportList={getEDCLupReportList}
      />
      <DeletedReportList
        Show={!toggle1}
        Hide={setToggle1}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        reportDeletedList={reportDeletedList}
        getEDCLupDeletedReportList={getEDCLupDeletedReportList}
        reportDeletedListCount={reportDeletedListCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreEDCLupData={softDeleteRestoreEDCLupData}
        Title={"Deleted Report History"}
      />
    </>
  );
};

export default ReportListing;
